/**
 * ****************************************************************************
 * @description     :   Store data and process common will use in page dashboard
 * @created at      :   2024/07/02
 * @created by      :   ANS833 – sondh@ans-asia.com
 * @package         :   Move
 * @copyright       :   Copyright (c) A.N.S Asia
 * @version         :   1.0.0
 * ****************************************************************************
 */
import repository from './repository';

const dataInit = {
    area: '',
    supplier: '',
    supplier_name: '',
    transportation_cd: '',
    transportation_name: '',
    price_cd: '',
    price_name: '',
    price_name_kana: '',
    basic_time: '',
    basic_fee: '',
    hourly_unit: '',
    hourly_rate: '',
    normal_extended_charge_kubun: '',
    late_night_extended_charge_kubun: '',
    // main_category: '',
    // conditions_1: '',
    // conditions_2: '',
    normal_extended_charge_criteria: '',
    late_night_extended_charge_criteria: '',
    specific_time: '',
    chk_disabled_key: true,
    extension_section: [],
    means: [],
    calculation: '1',
    fee: '',
    fee_late: '',
    starting_time_11: '',
    end_time_11: '',
    fee_11: '',
    condition_11: '',
    starting_time_12: '',
    end_time_12: '',
    fee_12: '',
    condition_12: '',
    starting_time_21: '',
    end_time_21: '',
    kubun_21: '',
    amount_21: '',
    condition_21: '',
    starting_time_22: '',
    end_time_22: '',
    kubun_22: '',
    amount_22: '',
    condition_22: '',
    customer_cd: '',
    customer_name: '',
    branch_cd: '',
    branch_name: '',
    all_branch: '',
    message: '',
    read_category_cd: '',
    time_estimate: '',
    priority: '',
    price_item1: '',
    price_item2: '',
    price_item3: '',
    price_item4: '',
    price_item5: '',
    price_item6: '',
    price_item7: '',
    price_item8: '',
    price_item9: '',
    price_item10: '',
    amount_line1: '',
    amount_line2: '',
    amount_line3: '',
    amount_line4: '',
    amount_line5: '',
    amount_line6: '',
    amount_line7: '',
    amount_line8: '',
    amount_line9: '',
    amount_line10: '',
    amount_line11: '',
    amount_line12: '',
    amount_line13: '',
    amount_line14: '',
    amount_line15: '',
    amount_line16: '',
    amount_line17: '',
    amount_line18: '',
    amount_line19: '',
    amount_line20: '',
    amount_line21: ''
};
const dataRefer = {
    area: '1',
    display: '1',
    supplier: '02030211',
    supplier_name: '牛すきやき(丼)',
    transportation_cd: '02030214',
    transportation_name: '海鮮チリソース炒め',
    price_cd: '00000565',
    price_name: 'ﾄﾗｲﾜｰｸｽ/9,000（基本交通費/課税）',
    price_name_kana: 'ﾄﾗｲﾜｰｸｽ/9,000（基本交通費/課税）',
    basic_time: '3',
    basic_fee: '9000',
    hourly_unit: '30',
    hourly_rate: '500',
    normal_extended_charge_kubun: '1',
    late_night_extended_charge_kubun: '2',
    // main_category: '1',
    // conditions_1: '1',
    // conditions_2: '1',
    normal_extended_charge_criteria: '1',
    late_night_extended_charge_criteria: '1',
    specific_time: '8',
    chk_disabled_key: true,
    means: [],
    extension_section: ['1'],
    calculation: '1',
    fee: '900',
    fee_late: '900',
    starting_time_11: '05:00',
    end_time_11: '08:00',
    fee_11: '500',
    condition_11: '1',
    starting_time_12: '00:00',
    end_time_12: '00:00',
    fee_12: '0',
    condition_12: '2',
    starting_time_21: '22:00',
    end_time_21: '23:00',
    kubun_21: '1',
    amount_21: '500',
    condition_21: '1',
    starting_time_22: '00:00',
    end_time_22: '04:59',
    amount_22: '4000',
    kubun_22: '1',
    condition_22: '1',
    customer_cd: '100104',
    customer_name: '（株）エイ・エヌ・エス',
    branch_cd: '1',
    branch_name: '東京支社',
    all_branch: '1',
    message: '10117：テスト見積 ご注文を受諾しました！',
    read_category_cd: '1',
    time_estimate: '',
    priority: '1',
    price_item1: '100',
    price_item2: '200',
    price_item3: '300',
    price_item4: '400',
    price_item5: '500',
    price_item6: '600',
    price_item7: '700',
    price_item8: '800',
    price_item9: '900',
    price_item10: '-1000',
    amount_line1: '100',
    amount_line2: '100',
    amount_line3: '1',
    amount_line4: '1000',
    amount_line5: '10000',
    amount_line6: '20000',
    amount_line7: '30000',
    amount_line8: '1',
    amount_line9: '200',
    amount_line10: '1',
    amount_line11: '1000',
    amount_line12: '1',
    amount_line13: '500',
    amount_line14: '1',
    amount_line15: '200',
    amount_line16: '1',
    amount_line17: '200',
    amount_line18: '1',
    amount_line19: '2000',
    amount_line20: '1',
    amount_line21: '5000'
};
const dataCopy = {
    area: '1',
    supplier: '02030211',
    supplier_name: '牛すきやき(丼)',
    transportation_cd: '02030214',
    transportation_name: '海鮮チリソース炒め',
    price_cd: '',
    price_name: 'ﾄﾗｲﾜｰｸｽ/9,000（基本交通費/課税）',
    price_name_kana: 'ﾄﾗｲﾜｰｸｽ/9,000（基本交通費/課税）',
    basic_time: '3',
    basic_fee: '9000',
    hourly_unit: '30',
    hourly_rate: '500',
    normal_extended_charge_kubun: '1',
    late_night_extended_charge_kubun: '2',
    // main_category: '1',
    // conditions_1: '1',
    // conditions_2: '1',
    normal_extended_charge_criteria: '1',
    late_night_extended_charge_criteria: '1',
    specific_time: '8',
    chk_disabled_key: true,
    means: [],
    extension_section: ['1'],
    calculation: '1',
    fee: '900',
    fee_late: '900',
    starting_time_11: '05:00',
    end_time_11: '08:00',
    fee_11: '500',
    condition_11: '1',
    starting_time_12: '00:00',
    end_time_12: '00:00',
    fee_12: '0',
    condition_12: '2',
    starting_time_21: '22:00',
    end_time_21: '23:00',
    kubun_21: '1',
    amount_21: '500',
    condition_21: '1',
    starting_time_22: '00:00',
    end_time_22: '04:59',
    amount_22: '4000',
    kubun_22: '1',
    condition_22: '1',
    customer_cd: '100104',
    customer_name: '（株）エイ・エヌ・エス',
    branch_cd: '1',
    branch_name: '東京支社',
    all_branch: '1',
    message: '10117：テスト見積 ご注文を受諾しました！',
    read_category_cd: '1',
    time_estimate: '',
    priority: '1',
    price_item1: '100',
    price_item2: '200',
    price_item3: '300',
    price_item4: '400',
    price_item5: '500',
    price_item6: '600',
    price_item7: '700',
    price_item8: '800',
    price_item9: '900',
    price_item10: '-1000',
    amount_line1: '100',
    amount_line2: '100',
    amount_line3: '1',
    amount_line4: '1000',
    amount_line5: '10000',
    amount_line6: '20000',
    amount_line7: '30000',
    amount_line8: '1',
    amount_line9: '200',
    amount_line10: '1',
    amount_line11: '1000',
    amount_line12: '1',
    amount_line13: '500',
    amount_line14: '1',
    amount_line15: '200',
    amount_line16: '1',
    amount_line17: '200',
    amount_line18: '1',
    amount_line19: '2000',
    amount_line20: '1',
    amount_line21: '5000'
};
const dataPage1 = [
    {
        no: '12',
        customer_code: '10104',
        customer_name: '（株）エイ・エヌ・エス',
        branch_cd: '1',
        branch_name: '東京支社',
        message: 'メッセージ管理のテスト ',
        status: '既読'
    },
    {
        no: '11',
        customer_code: '10104',
        customer_name: '（株）エイ・エヌ・エス',
        branch_cd: '1',
        branch_name: '東京支社',
        message: '納品書をアップロードしました！',
        status: '既読'
    },
    {
        no: '10',
        customer_code: '10104',
        customer_name: '（株）エイ・エヌ・エス',
        branch_cd: '1',
        branch_name: '東京支社',
        message: '納品書をアップロードしました！',
        status: '既読'
    },
    {
        no: '9',
        customer_code: '10104',
        customer_name: '（株）エイ・エヌ・エス',
        branch_cd: '1',
        branch_name: '東京支社',
        message: '10117:テスト見積 ご注文を受諾しました！',
        status: '既読'
    },
    {
        no: '7',
        customer_code: '10104',
        customer_name: '（株）エイ・エヌ・エス',
        branch_cd: '1',
        branch_name: '東京支社',
        message: '10117:テスト見積 ご注文を受諾しました！',
        status: '既読'
    }
];
const dataPage2 = [
    {
        no: '12',
        customer_code: '10104',
        customer_name: '（株）エイ・エヌ・エス',
        branch_cd: '1',
        branch_name: '東京支社',
        message: 'メッセージ管理のテスト ',
        status: '既読'
    },
    {
        no: '11',
        customer_code: '10104',
        customer_name: '（株）エイ・エヌ・エス',
        branch_cd: '1',
        branch_name: '東京支社',
        message: '納品書をアップロードしました！',
        status: '既読'
    },
    {
        no: '10',
        customer_code: '10104',
        customer_name: '（株）エイ・エヌ・エス',
        branch_cd: '1',
        branch_name: '東京支社',
        message: '納品書をアップロードしました！',
        status: '既読'
    },
    {
        no: '9',
        customer_code: '10104',
        customer_name: '（株）エイ・エヌ・エス',
        branch_cd: '1',
        branch_name: '東京支社',
        message: '10117:テスト見積 ご注文を受諾しました！',
        status: '既読'
    },
    {
        no: '7',
        customer_code: '10104',
        customer_name: '（株）エイ・エヌ・エス',
        branch_cd: '1',
        branch_name: '東京支社',
        message: '10117:テスト見積 ご注文を受諾しました！',
        status: '既読'
    }
];
export default {
    namespaced: true,
    state: {
        isSuccess: false,
        data: { ...dataInit, dataRefer, dataCopy },
        selectOptionKey: ['id', 'content'],
        totalRows: 0,
        listData: [],
        data_select: {
            areas: [
                {
                    code: 1,
                    name: '中日本統括部'
                },
                {
                    code: 2,
                    name: '北日本統括部'
                }
            ],
            means: [
                {
                    code: 1,
                    name: '請負(終了) 時間を超えた場合'
                },
                {
                    code: 2,
                    name: '特定の実働時間を超えた場合'
                }
            ],
            list_category: [
                {
                    code: 1,
                    name: '金額'
                },
                {
                    code: 2,
                    name: '割増'
                }
            ],
            list_conditions: [
                {
                    code: 1,
                    name: '一律'
                },
                {
                    code: 2,
                    name: '時間単位'
                }
            ],
            listSituation: [
                {
                    id: 0,
                    content: '状態1'
                },
                {
                    id: 1,
                    content: '状態2'
                }
            ],
            calculation_category: [
                {
                    code: 1,
                    name: '休憩時間は前から引く'
                },
                {
                    code: 2,
                    name: '休憩時間は後ろから引く'
                },
                {
                    code: 3,
                    name: '休憩時間を計算しない'
                }
            ],
            display: [
                {
                    code: 1,
                    name: '表示'
                },
                {
                    code: 2,
                    name: '非表示'
                }
            ]
        },
        msgNoData: '該当するデータが存在しません。'
    },
    mutations: {
        resetDataInit(state) {
            state.data = {
                ...dataInit,
                means: [],
                calculation_category: [],
                areas: []
            };
            state.listData = [];
            state.totalRows = 0;
            state.msgNoData = '該当するデータが存在しません。';
        },
        setListData(state, data) {
            state.listData = data ?? [];
            state.msgNoData = '';
        },
        setTotalRows(state, data) {
            state.totalRows = data;
        },
        setPageNavigation(state, data) {
            state.data.pageNo = data.currentPage;
            state.data.pageSize = data.perPage;
        },
        setPageNo(state, data) {
            state.data.pageNo = data;
        },
        setData(state, data) {
            state.data = data ?? [];
        },
        updateItemSupplier(state, data) {
            // state.data.supplier = data.item_id;
            state.data.supplier = data.item_code;
            state.data.supplier_name = data.item_name;
        }
        // updateItemTransportation(state, data) {
        //     // state.data.supplier = data.item_id;
        //     state.data.transportation_cd = data.item_code;
        //     state.data.transportation_name = data.item_name;
        // }
    },
    actions: {
        actionSearch(context, param) {
            try {
                if (param == 1) {
                    context.commit('setListData', dataPage1);
                } else {
                    context.commit('setListData', dataPage2);
                }
                context.commit('setTotalRows', 28);
            } catch (e) {
                console.log('Action saerch data screen: ' + e.message);
            }
        },
        getData(context, param) {
            try {
                console.log('context :>> ', context);
                console.log('param :>> ', param);
                // console.log('mode :>> ', mode);
                // let id = param['id'];
                let mode = param['mode'];
                if (mode == 1) {
                    context.commit('setData', dataCopy);
                } else {
                    context.commit('setData', dataRefer);
                }
            } catch (e) {
                console.log('Action get user info data screen: ' + e.message);
            }
        },
        /**
         * search shipping item
         * -----------------------------------------
         * @author : PhuongDT - 2024/05/30 - create
         * @params :
         * @access : private
         */
        searchItem(context, input) {
            try {
                repository.searchItem(input.body).then((res) => {
                    const { data } = res;
                    if (data.Code === 200) {
                        if (input.callback) {
                            input.callback(data);
                        }
                    } else {
                        if (input.onError) {
                            input.onError(data.Data.message);
                        }
                    }
                });
            } catch (e) {
                console.log('Action get data screen: ' + e.message);
            }
        }
    }
};
